(function () {
  var MODAL_SELECTOR = '[data-heathen-search-modal]';
  var STORAGE_RECENT_SEARCHES = 'heathen:search-recent';
  var STORAGE_RECENT_VIEWED = 'heathen:recently-viewed-handles';
  var LEGACY_VIEWED_KEYS = ['heathen_recently_viewed', 'recentlyViewedProducts', 'heathen_recently_viewed_handles'];
  var MAX_RECENT_SEARCHES = 6;
  var MAX_VIEWED_ITEMS = 4;
  var PRODUCT_CACHE_TTL_MS = 5 * 60 * 1000;
  var productCache = Object.create(null);

  function parseJson(raw, fallback) {
    try {
      return JSON.parse(raw);
    } catch (e) {
      return fallback;
    }
  }

  function normalizeHandle(value) {
    if (!value) return '';
    return String(value).trim().toLowerCase().replace(/[^a-z0-9\-]/g, '');
  }

  function normalizeTerm(value) {
    if (!value) return '';
    return String(value).replace(/\s+/g, ' ').trim();
  }

  function getRecentSearches() {
    var parsed = parseJson(localStorage.getItem(STORAGE_RECENT_SEARCHES), []);
    if (!Array.isArray(parsed)) return [];
    return parsed.map(normalizeTerm).filter(Boolean);
  }

  function setRecentSearches(items) {
    localStorage.setItem(STORAGE_RECENT_SEARCHES, JSON.stringify(items.slice(0, MAX_RECENT_SEARCHES)));
  }

  function pushRecentSearch(term) {
    var value = normalizeTerm(term);
    if (!value) return;
    var list = getRecentSearches().filter(function (item) {
      return item.toLowerCase() !== value.toLowerCase();
    });
    list.unshift(value);
    setRecentSearches(list);
  }

  function parseViewedFromRaw(raw) {
    var parsed = parseJson(raw, null);
    if (Array.isArray(parsed)) {
      return parsed
        .map(function (entry) {
          if (entry && typeof entry === 'object') return normalizeHandle(entry.handle);
          return normalizeHandle(entry);
        })
        .filter(Boolean);
    }

    if (parsed && Array.isArray(parsed.handles)) {
      return parsed.handles.map(normalizeHandle).filter(Boolean);
    }

    return String(raw || '')
      .split(/[,\s|]+/)
      .map(normalizeHandle)
      .filter(Boolean);
  }

  function parseViewedHandles() {
    var handles = parseViewedFromRaw(localStorage.getItem(STORAGE_RECENT_VIEWED));
    if (handles.length) return handles;

    for (var i = 0; i < LEGACY_VIEWED_KEYS.length; i++) {
      handles = parseViewedFromRaw(localStorage.getItem(LEGACY_VIEWED_KEYS[i]));
      if (handles.length) return handles;
    }
    return [];
  }

  function fallbackHandles(modal) {
    var raw = modal.getAttribute('data-fallback-handles') || '';
    return raw
      .split('|')
      .map(normalizeHandle)
      .filter(Boolean);
  }

  function money(cents) {
    var amount = Number(cents || 0) / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN';
    try {
      return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function createRecentNode(searchUrl, term) {
    var a = document.createElement('a');
    a.href = searchUrl + '?q=' + encodeURIComponent(term);
    a.textContent = term;
    a.className = 'heathen-search-recent-link';
    return a;
  }

  function renderRecent(modal) {
    var container = modal.querySelector('[data-role="recent-list"]');
    var empty = modal.querySelector('[data-role="recent-empty"]');
    var searchUrl = modal.getAttribute('data-search-url') || '/search';
    if (!container || !empty) return;

    var terms = getRecentSearches();
    container.innerHTML = '';
    if (!terms.length) {
      empty.hidden = false;
      return;
    }

    terms.forEach(function (term) {
      container.appendChild(createRecentNode(searchUrl, term));
    });
    empty.hidden = true;
  }

  function createProductNode(product, imageLoading) {
    var item = document.createElement('div');
    item.className = 'heathen-search-products__item';

    var link = document.createElement('a');
    link.className = 'heathen-search-product';
    link.href = product.url;
    if (product.title) link.title = product.title;

    var imageWrap = document.createElement('span');
    imageWrap.className = 'heathen-search-product__image';
    if (product.featured_image) {
      var img = document.createElement('img');
      img.src = product.featured_image;
      img.alt = product.title || '';
      img.loading = imageLoading === 'eager' ? 'eager' : 'lazy';
      if (imageLoading === 'eager' && img.fetchPriority !== undefined) img.fetchPriority = 'high';
      imageWrap.appendChild(img);
    }

    var meta = document.createElement('span');
    meta.className = 'heathen-search-product__meta';

    var brand = document.createElement('span');
    brand.className = 'heathen-search-product__brand';
    brand.textContent = product.vendor || '';

    var name = document.createElement('span');
    name.className = 'heathen-search-product__name';
    name.textContent = product.title || '';
    if (product.title) name.title = product.title;

    var price = document.createElement('span');
    price.className = 'heathen-search-product__price';
    var value = product.variants && product.variants[0] ? product.variants[0].price : product.price;
    price.textContent = money(value);

    if (brand.textContent) meta.appendChild(brand);
    meta.appendChild(name);
    meta.appendChild(price);
    link.appendChild(imageWrap);
    link.appendChild(meta);
    item.appendChild(link);

    return item;
  }

  function getCachedProduct(handle) {
    var entry = productCache[handle];
    if (!entry || !entry.product) return null;
    if (Date.now() - entry.ts > PRODUCT_CACHE_TTL_MS) {
      delete productCache[handle];
      return null;
    }
    return entry.product;
  }

  function setCachedProduct(handle, product) {
    if (!handle || !product) return;
    productCache[handle] = { product: product, ts: Date.now() };
  }

  function dedupeHandles(handles) {
    var seen = Object.create(null);
    var out = [];
    handles.forEach(function (h) {
      if (!h || seen[h]) return;
      seen[h] = true;
      out.push(h);
    });
    return out;
  }

  function fetchProductJson(handle, signal) {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
    return fetch(root + 'products/' + handle + '.js', {
      credentials: 'same-origin',
      signal: signal,
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function createSkeletonNode(handle) {
    var item = document.createElement('div');
    item.className = 'heathen-search-products__item heathen-search-products__item--skeleton';
    item.setAttribute('data-skeleton-handle', handle);
    var inner = document.createElement('div');
    inner.className = 'heathen-search-product heathen-search-product--skeleton';
    inner.setAttribute('aria-hidden', 'true');
    inner.innerHTML =
      '<span class="heathen-search-product__image heathen-search-product__image--skeleton"></span>' +
      '<span class="heathen-search-product__meta heathen-search-product__meta--skeleton">' +
      '<span class="heathen-search-skeleton-line heathen-search-skeleton-line--brand"></span>' +
      '<span class="heathen-search-skeleton-line heathen-search-skeleton-line--title"></span>' +
      '<span class="heathen-search-skeleton-line heathen-search-skeleton-line--price"></span>' +
      '</span>';
    item.appendChild(inner);
    return item;
  }

  function replaceSkeletonWithProduct(list, handle, product) {
    var skeleton = list.querySelector('[data-skeleton-handle="' + handle + '"]');
    if (!skeleton) return;
    var eager = skeleton === list.firstElementChild;
    skeleton.replaceWith(createProductNode(product, eager ? 'eager' : 'lazy'));
  }

  function removeSkeleton(list, handle) {
    var sk = list.querySelector('[data-skeleton-handle="' + handle + '"]');
    if (sk) sk.remove();
  }

  function renderViewed(modal, options) {
    var list = modal.querySelector('[data-role="viewed-products"]');
    var empty = modal.querySelector('[data-role="viewed-empty"]');
    if (!list || !empty) return;

    options = options || {};
    var signal = options.signal;
    var sessionGen = options.generation;

    var handles = dedupeHandles(parseViewedHandles());
    if (!handles.length) handles = dedupeHandles(fallbackHandles(modal));
    handles = handles.slice(0, MAX_VIEWED_ITEMS);

    list.classList.remove('is-loading');
    list.innerHTML = '';
    if (!handles.length) {
      empty.hidden = false;
      return;
    }

    empty.hidden = true;

    var pendingFetches = 0;
    var completedFetches = 0;

    handles.forEach(function (handle) {
      var cached = getCachedProduct(handle);
      if (cached) {
        var eagerFirst = list.children.length === 0;
        list.appendChild(createProductNode(cached, eagerFirst ? 'eager' : 'lazy'));
        return;
      }
      pendingFetches += 1;
      list.appendChild(createSkeletonNode(handle));
    });

    if (!pendingFetches) {
      empty.hidden = list.children.length > 0;
      return;
    }

    list.classList.add('is-loading');

    function tryFinishLoading() {
      if (sessionGen != null && modal._heathenViewedGen !== sessionGen) return;
      if (completedFetches < pendingFetches) return;
      requestAnimationFrame(function () {
        if (sessionGen != null && modal._heathenViewedGen !== sessionGen) return;
        list.classList.remove('is-loading');
        if (!list.children.length) {
          empty.hidden = false;
        } else {
          empty.hidden = true;
        }
      });
    }

    handles.forEach(function (handle) {
      if (getCachedProduct(handle)) return;

      fetchProductJson(handle, signal).then(function (product) {
        var stale = sessionGen != null && modal._heathenViewedGen !== sessionGen;
        var aborted = Boolean(signal && signal.aborted);

        if (!stale && !aborted) {
          if (product) {
            setCachedProduct(handle, product);
            requestAnimationFrame(function () {
              if (sessionGen != null && modal._heathenViewedGen !== sessionGen) return;
              replaceSkeletonWithProduct(list, handle, product);
            });
          } else {
            requestAnimationFrame(function () {
              if (sessionGen != null && modal._heathenViewedGen !== sessionGen) return;
              removeSkeleton(list, handle);
            });
          }
        }

        completedFetches += 1;
        tryFinishLoading();
      });
    });
  }

  function searchContainer(wrapper) {
    return wrapper._heathenSearchContainer || wrapper.querySelector('.search-form-container');
  }

  function portalHost(wrapper) {
    var header = wrapper.closest('.custom-header');
    return (header && header.parentElement) || document.body;
  }

  function mountContainer(wrapper) {
    var container = searchContainer(wrapper);
    var host = portalHost(wrapper);
    if (!container || !host || container.parentElement === host) return container;
    host.appendChild(container);
    return container;
  }

  function closeAccountLayers() {
    document.querySelectorAll('[data-account-dropdown].active').forEach(function (dropdown) {
      dropdown.classList.remove('active');
      dropdown.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-account-trigger][aria-expanded="true"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function closeCartLayers() {
    document.querySelectorAll('[data-cart-dropdown].active').forEach(function (dropdown) {
      dropdown.classList.remove('active');
      dropdown.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-cart-trigger][aria-expanded="true"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function openSearch(wrapper) {
    var container = mountContainer(wrapper);
    var input = wrapper.querySelector('.heathen-search-input');
    if (!container) return;
    container.setAttribute('aria-hidden', 'false');
    if (input) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          try {
            input.focus({ preventScroll: true });
          } catch (err) {
            input.focus();
          }
        });
      });
    }
  }

  function closeSearch(wrapper) {
    var container = searchContainer(wrapper);
    if (!container) return;
    container.setAttribute('aria-hidden', 'true');
    if (wrapper && wrapper._heathenViewedAbort) {
      try {
        wrapper._heathenViewedAbort.abort();
      } catch (err) {
        /* ignore */
      }
    }
  }

  function bindSearch(wrapper) {
    if (!wrapper || wrapper.dataset.heathenSearchBound === '1') return;
    wrapper.dataset.heathenSearchBound = '1';

    var trigger = wrapper.querySelector('.search-trigger');
    var modal = wrapper.querySelector(MODAL_SELECTOR);
    var form = wrapper.querySelector('.heathen-search-form');
    var input = wrapper.querySelector('.heathen-search-input');
    if (!trigger || !modal || !form) return;
    wrapper._heathenSearchContainer = wrapper.querySelector('.search-form-container');
    mountContainer(wrapper);
    renderRecent(modal);

    function refreshContent() {
      modal._heathenViewedGen = (modal._heathenViewedGen || 0) + 1;
      var sessionGen = modal._heathenViewedGen;
      if (wrapper._heathenViewedAbort) {
        try {
          wrapper._heathenViewedAbort.abort();
        } catch (err) {
          /* ignore */
        }
      }
      wrapper._heathenViewedAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var signal = wrapper._heathenViewedAbort ? wrapper._heathenViewedAbort.signal : undefined;

      renderRecent(modal);
      renderViewed(modal, { signal: signal, generation: sessionGen });
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var container = searchContainer(wrapper);
      var hidden = !container || container.getAttribute('aria-hidden') === 'true';
      if (hidden) {
        closeAccountLayers();
        closeCartLayers();
        mountContainer(wrapper);
        refreshContent();
        openSearch(wrapper);
      } else {
        closeSearch(wrapper);
      }
    });

    form.addEventListener('submit', function () {
      if (input) pushRecentSearch(input.value);
    });

    wrapper.querySelectorAll('[data-search-tag]').forEach(function (tagLink) {
      tagLink.addEventListener('click', function () {
        pushRecentSearch(tagLink.getAttribute('data-search-tag'));
      });
    });

    document.addEventListener('click', function (e) {
      var container = searchContainer(wrapper);
      var isInsideTrigger = wrapper.contains(e.target);
      var isInsideContainer = container && container.contains(e.target);
      if (!isInsideTrigger && !isInsideContainer) closeSearch(wrapper);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var container = searchContainer(wrapper);
      if (!container || container.getAttribute('aria-hidden') !== 'false') return;
      closeSearch(wrapper);
    });

  }

  function init() {
    document.querySelectorAll('[data-heathen-search]').forEach(bindSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-heathen-search]').forEach(bindSearch);
  });
})();
